import axiosPost from "./axiosPost";

export const SFHotelUsuarioGet = async (credentials, data) => {
    const body = {
        service: "SFHotelUsuarioGet",
        params: {
            SFHotelId: data?.SFHotelId ?? null,
            SFHabitacionId: data?.SFHabitacionId ?? null,
            fecha: data?.fecha ?? null,
            SFHabitacionHuespedStatus: data?.reservaStatus ?? null,
        },
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
